// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagement.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Management component
 */
import React from 'react';

import TenantList from './Izenda.TenantList';
import TenantDetail from './Izenda.TenantDetail';
import Header from './Izenda.TenantListHeader';
import MiddlePanel from 'share/components/layout/Izenda.MiddlePanel';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import connect from 'share/enhancers/Izenda.Connect';

import actions from './Izenda.TenantManagementActions';

const TenantManagement = ({ store }: { store: any }) => {
  return (
    <section className='izenda-TenantManagement izenda-TableLayout'>
      <MiddlePanel minWidth={store.getBundle().MIDDLE_MIN_WIDTH} maxWidth={store.getBundle().MIDDLE_MAX_WIDTH}>
        <div className='u_fullHeight u-posRelative u-bgWhite izenda-Middle-section'>
          <Header store={store} />
          <div className='izenda-MiddlePanel-content izenda-TenantList-content'>
            <ScrollBox>
              <TenantList store={store} />
            </ScrollBox>
          </div>
        </div>
      </MiddlePanel>
      <TenantDetail store={store} />
    </section>
  );
};

export default connect(actions)(TenantManagement);



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantManagement.js